<div class="container">
  <h1 class="page-title"
    [helpCenterButton]="permissionCode" [lang]="currentLang"
    [helpCenterDownloadButton]="permissionCode" [position]="'inline'" [lang]="currentLang">
    <span class="icon"><em class="fas fa-list-check"></em></span
    >{{ "Purchase.Header" | translate }}
  </h1>
  <p-card>
    <p-accordion>
      <p-accordionTab
        header="{{ 'Common.Form.Header' | translate }}"
        [selected]="isSearchFormOpen"
      >
        <form [formGroup]="searchForm">
          <div class="p-fluid grid">
            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <div class="block">
                <h3 class="font-bold mt-0 mb-2">
                  {{ "Purchase.Search.Priority" | translate }}
                </h3>
              </div>
              <div class="block">
                <div class="formgroup-inline">
                  <div class="field-checkbox">
                    <p-checkbox
                      [formControl]="$any(searchForm).controls['priorities']"
                      value="1"
                      label="{{ 'Purchase.Search.Urgent' | translate }}"
                    ></p-checkbox>
                  </div>
                  <div class="field-checkbox">
                    <p-checkbox
                      [formControl]="$any(searchForm).controls['priorities']"
                      value="5"
                      class="ml-2"
                      label="{{ 'Purchase.Search.Normal' | translate }}"
                    ></p-checkbox>
                  </div>
                </div>
              </div>
            </div>
            <div class="field col-12 md:col-6 lg:col-3 mb-3">
              <h3 class="font-bold mt-0 mb-2">
                {{ "Purchase.Search.Vendor" | translate }}
              </h3>
              <p-multiSelect
                inputId="formVendorNumber"
                appendTo="body"
                placeholder="{{ 'Common.DropDown.Select' | translate }}"
                formControlName="vendorNumbers"
                [showToggleAll]="false"
                [virtualScroll]="true"
                [itemSize]="40"
                [options]="vendorNumberOptions"
              >
              </p-multiSelect>
            </div>
            <div class="field col-12 md:col-6 lg:col-3 mb-3">
              <h3 class="font-bold mt-0 mb-2">
                {{ "Purchase.Search.Facility" | translate }}
              </h3>
              <laas-facility-dropdown 
                formControlName="facilitys" 
                [isMultiple]="true" 
                [showFilter]="true"
                [showToggleAll]="true">
              </laas-facility-dropdown> 
            </div>
            <div class="field col-12 md:col-6 lg:col-3 mb-3">
              <h3 class="font-bold mt-0 mb-2">
                {{ "Purchase.Search.AdNo" | translate }}
              </h3>
              <p-chips
                formControlName="adNos"
                separator=","
                (onAdd)="onChipsAdd($event, 'adNos')"
              ></p-chips>
            </div>
            <div class="field col-12 md:col-6 lg:col-3 mb-3">
              <div class="block">
                <h3 class="font-bold mt-0 mb-2">
                  {{ "Purchase.Search.OrderQueryScope" | translate }}
                </h3>
              </div>
              <div class="block">
                <div class="formgroup-inline">
                  <div class="field-radiobutton">
                    <p-radioButton
                      formControlName="orderQueryScope"
                      [value]="OrderQueryScopeEnum.personal"
                      label="{{ 'Purchase.Search.PersonalOrder' | translate }}"
                    ></p-radioButton>
                  </div>
                  <div class="field-radiobutton">
                    <p-radioButton
                      formControlName="orderQueryScope"
                      [value]="OrderQueryScopeEnum.all"
                      label="{{ 'Purchase.Search.All' | translate }}"
                    ></p-radioButton>
                  </div>
                </div>
              </div>
            </div>
            <div class="field col-12 md:col-6 lg:col-3 mb-3">
              <h3 class="font-bold mt-0 mb-2">
                {{ "Purchase.Search.ExpressBill" | translate }}
              </h3>
              <p-chips
                formControlName="billOfLadings"
                separator=","
                (onAdd)="onChipsAdd($event, 'billOfLadings')"
              ></p-chips>
            </div>
            <div class="field col-12 md:col-6 lg:col-3 mb-3">
              <h3 class="font-bold mt-0 mb-2">
                {{ "Purchase.Search.Forwarder" | translate }}
              </h3>
              <p-dropdown
                [options]="forwarderOptions"
                formControlName="forwarder"
                [filter]="true"
                placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
              ></p-dropdown>
            </div>
            <div class="field col-12 md:col-6 lg:col-3 mb-3">
              <h3 class="font-bold mt-0 mb-2">
                {{ "Purchase.Search.ImportDeclarationNo" | translate }}
              </h3>
              <p-chips
                formControlName="importDeclarationNos"
                separator=","
                (onAdd)="onChipsAdd($event, 'importDeclarationNos')"
              ></p-chips>
            </div>
            <div class="field col-12 md:col-6 lg:col-3 mb-3">
              <h3 class="font-bold mt-0 mb-2">
                {{ "Purchase.Search.InvoiceNo" | translate }}
              </h3>
              <p-chips
                formControlName="invoiceNos"
                separator=","
                (onAdd)="onChipsAdd($event, 'invoiceNos')"
              ></p-chips>
            </div>
            <div class="field col-12 md:col-6 lg:col-3 mb-3">
              <h3 class="font-bold mt-0 mb-2">
                {{ "Purchase.Search.Status" | translate }}
              </h3>
              <p-multiSelect
                [options]="statusOptions"
                formControlName="docStatus"
                placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                [filter]="true"
              ></p-multiSelect>
            </div>
            <div class="field col-12 md:col-6 lg:col-3 laas-calendar">
              <laas-calendar
                #createDt
                [title]="'Purchase.Search.CreateDt'"
                [isH3Title]="true"
                [defaultDate]="defaultCreateDt"
                [showRangeMode]="true"
                [showStartMode]="true"
                (onDateChange)="dateOnChange($event, 'createDt')"
              >
              </laas-calendar>
            </div>

            <div class="field col-12 md:col-6 lg:col-3 mb-3">
              <h3 class="font-bold mt-0 mb-2">
                {{ "Purchase.Search.Creater" | translate }}
              </h3>
              <p-multiSelect
                [options]="pcsrAndCsrOptions"
                formControlName="pcsrAndCsrList"
                placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                [filter]="true"
              ></p-multiSelect>
            </div>
          </div>
          <div class="grid block">
            <div class="col">
              <button
                pButton
                type="button"
                (click)="searchClick($event)"
                label="{{ 'Common.Button.Search' | translate }}"
                icon="pi pi-search"
                iconPos="right"
              ></button>
              <button
                pButton
                pRipple
                (click)="resetBtnClick($event)"
                label="{{ 'Common.Button.Reset' | translate }}"
                class="p-button-secondary ml-2"
              ></button>
            </div>
          </div>
        </form>
      </p-accordionTab>
    </p-accordion>
    <div class="mt-2">
      <laas-data-table
        id="purchaseSearchMainTable"
        #table
        [expandable]="false"
        [tableKey]="preferenceKey"
        [defaultColumns]="dataTableColumns"
        [dataKey]="'rownum'"
        [value]="results"
        [loading]="isLoading"
        [selectable]="true"
        [(selectedRows)]="selectedRows"
        (tableOnPage)="tablePageChange($event)"
        (tableOnSort)="tableSort($event)"
        [lazy]="true"

      >
        <ng-template pTemplate="caption">
          <div class="col">
            <button
              pButton
              pRipple
              icon="pi pi-file"
              [disabled]="selectedRows.length == 0"
              (click)="openFileManagement($event)"
              class="p-button-success ml-4"
            ></button>
          </div>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns">
          <td
            *ngFor="let col of columns"
            [ngClass]="{
              'row-red': rowData.docStatus === '42',
              'row-gray': rowData.docStatus === '5'
            }"
          >
            <ng-container [ngSwitch]="col.field">
              <ng-container *ngSwitchCase="'adNo'">
                <div class="overflow-text">
                  <a
                    href="javascript: void(0);"
                    (click)="
                      gotoProgress(
                        $event,
                        rowData.adNo,
                        rowData.facility,
                        rowData.billOfLading,
                        '1',
                        rowData.whNo
                      )
                    "
                    >{{ rowData[col.field] }}</a
                  >
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'billOfLading'">
                <div class="overflow-text">
                  <a
                    href="javascript: void(0);"
                    (click)="
                      gotoProgress(
                        $event,
                        rowData.adNo,
                        rowData.facility,
                        rowData.billOfLading,
                        '2',
                        rowData.whNo
                      )
                    "
                    >{{ rowData[col.field] }}</a
                  >
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'docStatus'">
                <div class="overflow-text">
                  {{
                    rowData[col.field]
                      | optionsMapping : statusOptions
                      | replaceNullWith : "-"
                  }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'priority'">
                <div class="overflow-text">
                  {{
                    rowData[col.field]
                      | optionsMapping : transportPriorityOptions
                      | replaceNullWith : "-"
                  }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'createDt'">
                <div class="overflow-text">
                  {{
                    rowData[col.field]
                      | date : "yyyy-MM-dd"
                      | replaceNullWith : "-"
                  }}
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="'vendor'">
                <div class="overflow-text">
                  {{ rowData[col.field] }}
                </div>
              </ng-container>

              <ng-container *ngSwitchDefault>
                <div [ngSwitch]="col.dataType" class="overflow-text">
                  <ng-container *ngSwitchCase="'date'">
                    {{
                      rowData[col.field]
                        | date : "yyyy-MM-dd HH:mm:ss"
                        | replaceNullWith : "-"
                    }}
                  </ng-container>
                  <ng-container *ngSwitchDefault>
                    {{ rowData[col.field] | replaceNullWith : "-" }}
                  </ng-container>
                </div>
              </ng-container>
            </ng-container>
          </td>
        </ng-template>
      </laas-data-table>
    </div>
  </p-card>
</div>

<p-dialog
  (onShow)="onShowFileManagement($event)"
  [style]="{ width: '65vw' }"
  [(visible)]="isShowFileManagement"
  appendTo="body"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
>
  <p-header style="color: royalblue">{{ 'ReceiptForm.Button.UploadAttachment' | translate }}</p-header>
  <laas-file-management
    #fileManagement
    *ngIf="getReferenceKeys().length"
    [fileCategory]="fileCategory"
    [referenceKeys]="getReferenceKeys()"
    [headerString]="'AdNo: ' + getReferenceKeys().join(', ')"
  ></laas-file-management>
  <laas-file-management
    #fileManagementHawbNo
    *ngIf="getReferenceKeysOfHawbNo().length"
    [fileCategory]="fileCategoryHawbNo"
    [referenceKeys]="getReferenceKeysOfHawbNo()"
    [headerString]="'提單號碼: ' + getReferenceKeysOfHawbNo().join(', ')"
  ></laas-file-management>
</p-dialog>
<help-dock
  [permissionCode]="permissionCode"
  [lang]="currentLang">
</help-dock>
